import React from 'react';
import { Chip, Box, alpha, useTheme } from '@mui/material';

export default function StatusBadge({
  status,
  label,
  size = 'small',
  dot = true,
  sx = {},
}) {
  const theme = useTheme();
  const rawStatus = String(status || label || '').toLowerCase().trim();
  const displayLabel = label || status || 'Unknown';

  let colorScheme = {
    bg: alpha(theme.palette.grey[500], 0.1),
    color: theme.palette.text.secondary,
    dotColor: theme.palette.grey[500],
    border: alpha(theme.palette.grey[500], 0.2),
  };

  if (
    ['active', 'activated', 'published', 'verified', 'completed', 'paid', 'approved', 'success', 'delivered', 'accepted'].includes(rawStatus)
  ) {
    colorScheme = {
      bg: theme.palette.mode === 'dark' ? alpha(theme.palette.success.main, 0.16) : theme.palette.success.lighter,
      color: theme.palette.mode === 'dark' ? theme.palette.success.light : theme.palette.success.dark,
      dotColor: theme.palette.success.main,
      border: alpha(theme.palette.success.main, 0.25),
    };
  } else if (
    ['pending', 'under_review', 'under review', 'processing', 'in_progress', 'draft', 'warning', 'requested'].includes(rawStatus)
  ) {
    colorScheme = {
      bg: theme.palette.mode === 'dark' ? alpha(theme.palette.warning.main, 0.16) : theme.palette.warning.lighter,
      color: theme.palette.mode === 'dark' ? theme.palette.warning.light : theme.palette.warning.darker,
      dotColor: theme.palette.warning.main,
      border: alpha(theme.palette.warning.main, 0.25),
    };
  } else if (
    ['inactive', 'deactivated', 'blocked', 'cancelled', 'rejected', 'failed', 'expired', 'error', 'suspended', 'deleted', 'banned'].includes(rawStatus)
  ) {
    colorScheme = {
      bg: theme.palette.mode === 'dark' ? alpha(theme.palette.error.main, 0.16) : theme.palette.error.lighter,
      color: theme.palette.mode === 'dark' ? theme.palette.error.light : theme.palette.error.dark,
      dotColor: theme.palette.error.main,
      border: alpha(theme.palette.error.main, 0.25),
    };
  } else if (
    ['info', 'service', 'lead', 'customer', 'buyer', 'seller', 'partner'].includes(rawStatus)
  ) {
    colorScheme = {
      bg: theme.palette.mode === 'dark' ? alpha(theme.palette.info.main, 0.16) : theme.palette.info.lighter,
      color: theme.palette.mode === 'dark' ? theme.palette.info.light : theme.palette.info.dark,
      dotColor: theme.palette.info.main,
      border: alpha(theme.palette.info.main, 0.25),
    };
  }

  return (
    <Chip
      size={size}
      icon={
        dot ? (
          <Box
            component="span"
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: colorScheme.dotColor,
              ml: '6px !important',
              mr: '-2px !important',
            }}
          />
        ) : undefined
      }
      label={displayLabel}
      sx={{
        fontWeight: 600,
        fontSize: size === 'small' ? '0.75rem' : '0.8125rem',
        height: size === 'small' ? 22 : 26,
        borderRadius: '6px',
        bgcolor: colorScheme.bg,
        color: colorScheme.color,
        border: `1px solid ${colorScheme.border}`,
        ...sx,
      }}
    />
  );
}
